var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    fill: "#09041C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8423 34V25.7899H27.4948L27.8926 22.5894H24.8423V20.5463C24.8423 19.62 25.089 18.9887 26.3694 18.9887L28 18.988V16.1253C27.7181 16.0873 26.7502 16 25.6236 16C23.271 16 21.6605 17.4913 21.6605 20.2293V22.5894H19V25.7899H21.6605V34H24.8423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.d3dba5e9b74aaf39f4ac333c36061afa.svg";
export { ForwardRef as ReactComponent };